// Malha de municipios do IBGE (public/municipios.geojson, ~11 MB). Tanto a aba
// Mapa quanto o mini-mapa da barra lateral usam o mesmo arquivo, entao o fetch
// e o parse ficam memoizados aqui (uma vez por sessao).

const GEOJSON_URL = "/municipios.geojson";

let geojsonPromise: Promise<any> | null = null;

export function loadMunicipiosGeojson(): Promise<any> {
  if (geojsonPromise) return geojsonPromise;
  geojsonPromise = fetch(GEOJSON_URL).then((response) => {
    if (!response.ok) throw new Error("Falha ao carregar a malha de municipios");
    return response.json();
  });
  return geojsonPromise;
}
